import type { AccommodationMetadata, BedType, WifiSpeed, WifiStability } from "~/lib/api";
import { pluralize } from "~/lib/format";

export const BED_TYPE_LABELS: Record<BedType, string> = {
  single: "single",
  double: "double",
  queen: "queen",
  king: "king",
  bunk: "bunk",
  "sofa-bed": "sofa bed",
  bassinet: "bassinet",
};

export const WIFI_SPEED_LABELS: Record<WifiSpeed, string> = {
  slow: "Slow",
  regular: "Regular",
  fast: "Fast",
  "very-fast": "Very fast",
};

export const WIFI_SPEED_HINTS: Record<WifiSpeed, string> = {
  slow: "< 20 Mbps",
  regular: "< 60 Mbps",
  fast: "< 150 Mbps",
  "very-fast": "150+ Mbps",
};

export const WIFI_STABILITY_LABELS: Record<WifiStability, string> = {
  unstable: "Unstable",
  stable: "Stable",
  flawless: "Flawless",
};

export function formatWorkSummary(metadata: Pick<AccommodationMetadata, "workspaces" | "wifi">): string {
  const parts: string[] = [];
  if (metadata.workspaces) {
    parts.push(pluralize(metadata.workspaces, "desk"));
  }
  if (metadata.wifi?.speed) {
    const speed = WIFI_SPEED_LABELS[metadata.wifi.speed] ?? metadata.wifi.speed;
    const stability = metadata.wifi.stability
      ? ` (${WIFI_STABILITY_LABELS[metadata.wifi.stability].toLowerCase()})`
      : "";
    parts.push(`${speed} wifi${stability}`);
  }
  return parts.join(" · ");
}
